import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import ReactQuill from 'react-quill';
import {quillConfig} from '../../../mock/quill-config';
import {useFormik} from 'formik';
import {createNewsSchema} from "../../../schema/newsSchema";
import {UploadImage} from "../../../components/common/uploadImage/UploadImage";
import {LANGUAGES} from "../../../mock/languages";
import {createNews} from "../../../services/newsSvc";
import {useNotification} from "../../../context/NotificationContext";
import {lang} from "../../../types/lang";

export const NewsCreatePage = () => {
  const navigate = useNavigate();
  const {formatMessage} = useIntl();
  const {showNotification} = useNotification();
  const [activeTab, setActiveTab] = useState<lang>("uz");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: {
        uz: '',
        ru: '',
        en: '',
      },
      description: {
        uz: '',
        ru: '',
        en: '',
      },
      banner: null,
    },
    validationSchema: createNewsSchema,
    onSubmit: async (values, {
      resetForm
    }) => {
      const formData = new FormData();
      formData.append('title_uz', values.title.uz);
      formData.append('title_ru', values.title.ru);
      formData.append('title_en', values.title.en);
      formData.append('description_uz', values.description.uz);
      formData.append('description_ru', values.description.ru);
      formData.append('description_en', values.description.en);

      if (values.banner) {
        formData.append('banner', values.banner);
      }

      try {
        const res = await createNews(formData);
        if (res?.success) {
          showNotification("Muvaffaqiyatli", "Yangilik qo'shildi", "success")
          resetForm();
          setTimeout(() => {
            navigate(-1)
          }, 1000)
        }
      } catch (e) {
        showNotification("Xatolik!", "", "error")
      }
    },
  });

  const handleTabChange = (lang) => {
    setActiveTab(lang);
  };

  return (
      <div>
        <div className={"card"}>
          <div className="card-header">
            <h1 className="card-title">Yangilik qo'shish</h1>
            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
              {LANGUAGES.map((lang) => (
                  <li className="nav-item" key={lang.key}>
                    <button
                        className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                        onClick={() => handleTabChange(lang.key)}
                    >
                      {lang.name}
                    </button>
                  </li>
              ))}
            </ul>
          </div>
          <div className="card-body">
            <div id="kt_account_profile_details" className="collapse show">
              <form
                  className="form"
                  onSubmit={formik.handleSubmit}
                  encType="multipart/form-data"
              >
                <div className="card-body p-9">
                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Yangilik nomi
                    </label>
                    <div className="col-lg-8 fv-row">
                    <textarea
                        className="form-control form-control-lg form-control-solid"
                        placeholder="Yangilik nomi"
                        name={`title.${activeTab}`}
                        value={formik.values.title[activeTab]}
                        onChange={formik.handleChange}
                    />
                      {formik.touched.title?.[activeTab] && formik.errors.title?.[activeTab] && (
                          <div className="text-danger">{formik.errors.title[activeTab]}</div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label fw-bold fs-6">
                      <span className="required">Yangilik matni</span>
                    </label>
                    <div className="col-lg-8 fv-row">
                      <div className={"h-200px"}>
                        <ReactQuill
                            key={activeTab}
                            style={{
                              height: "150px",
                            }}
                            formats={quillConfig?.formats}
                            modules={quillConfig?.modules}
                            value={formik.values.description[activeTab]}
                            onChange={(value) =>
                                formik.setFieldValue(`description.${activeTab}`, value)
                            }
                        />
                      </div>
                      {formik.touched.description?.[activeTab] && formik.errors.description?.[activeTab] && (
                          <div className="text-danger">{formik.errors.description[activeTab]}</div>
                      )}
                    </div>
                  </div>

                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Banner rasmi
                    </label>
                    <div className="col-lg-8 fv-row">
                      <UploadImage imageSizes={"banner"} onImageUpload={(file) => {
                        if (file) {
                          formik.setFieldValue('banner', file);
                        }
                      }}/>
                      {formik.touched.banner && formik.errors.banner && (
                          <div className="text-danger">{formik.errors.banner}</div>
                      )}
                    </div>
                  </div>



                </div>
                <div className="card-footer">
                  <div className="justify-content-end d-flex gap-2">
                    <button
                        className="btn btn-secondary"
                        onClick={() => navigate(-1)}
                        type="button"
                    >
                      {formatMessage({id: "Bekor qilish"})}
                    </button>
                    <button
                        className="btn btn-primary"
                        type="submit"
                    >
                      {formatMessage({id: "Saqlash"})}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  );
};